<div class="header-of-payment">
  <div class="info-box" *ngIf="flashPaymentService.controller.transactionType === 'INVOICE PAYMENTS'">

    <div>
      <div class="head-info-container">
        <div class="head-text">
          Resumen de Factura
        </div>
        <div class="download-pdf" (click)="flashPaymentService.downloadLastInvoice()">
          <span>Descargar mi factura</span>
        </div>
      </div>

      <hr>

      <div class="invoice-amount row mt-3 justify-content-between">
        <div class="col-lg-3 border-right date-box">
          <img
            src="../../assets/images/netflixicon1.png"
            alt=""
            class="invoice-icon"
          />
          <div>
            <div class="">Fecha de Vencimiento</div>
            <div class="data-title">{{billDueDateField | date: 'MM/dd/yyyy'}}</div>
          </div>

        </div>
        <div class="col-lg-7 border-right">
          <div class="box-info-list">
            <div class="box-info-active mb-2">
              <div class="info-mark-active"></div>
              <div>
                <div class="">Saldo de factura</div>
                <div
                  class="data-title"
                  (click)="changeAmount(billBalanceField)"
                >
                  {{this.billBalanceField }}
                </div>
              </div>
            </div>

            <div class="box-info mb-2">
              <div class="info-mark"></div>
              <div class="">
                <div class="">Importe vencido</div>
                <div
                  class="data-title"
                  (click)="changeAmount(pastDueAmountField)"
                >
                  {{this.pastDueAmountField | currency}}
                </div>
              </div>
            </div>

            <div class="box-info mb-2 desktop">
              <div class="info-mark"></div>
              <div class="">
                <div class="">&Uacute;ltimo pago</div>
                <div class="data-title" (click)="changeAmount(this.lastPaymentAmountField)">
                  {{this.lastPaymentAmountField | currency}}
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="col-lg-2 mt-2">
          <div class="data-title">Total a pagar</div>
          <div>
            <div class="pay-action-container">
              <div class="amount" (click)="activateChange()"
                   *ngIf="!canUpdateAmount"> {{ flashPaymentService.controller.operationAmount | currency }}</div>
              <div class="amount" *ngIf="canUpdateAmount">
                <input
                  type="text"
                  [(ngModel)]="editOperationAmount"
                  name="operationAmount"
                  (change)="activateChange(editOperationAmount, true)"
                  appTwoDigitDecimalNumber
                  class="max-width-fix"
                >
              </div>
              <div class="continue-button" (click)="goToProcess()">continuar
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="prepaid-container max-width"
       *ngIf="flashPaymentService.controller.transactionType === 'PREPAID PRODUCT RECHARGES'">
    <div class="prepaid-title mb-2">
      Recarga Prepago
    </div>
    <div class="prepaid-head-content">
      <div class="prepaid-head-item">
        <div class="box-info-active mb-2">
          <div class="info-mark-active"></div>
          <div>
            <div class="">Balance en Prepago</div>
            <div
              class="data-title"
            >
              {{prepaidBalance | currency}}
            </div>
          </div>
        </div>
      </div>

      <div class="prepaid-head-item">
        <div class="data-title"> Monto a recargar</div>
        <div>
          <div class="pay-action-container">
            <div class="amount"> {{ flashPaymentService.controller.operationAmount | currency }}</div>
            <div class="continue-button" (click)="goToProcess()">
              continuar
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

  <div class="prepaid-container max-width intallment-container"
       *ngIf="flashPaymentService.controller.transactionType === 'INSTALLMENT ACCELERATION'">
    <div class="prepaid-title mb-2">
      Acelereci&oacute;n de installment
    </div>
    <div class="prepaid-head-content">
      <div class="prepaid-head-item">
        <div class="box-info-active mb-2">
          <div class="info-mark-active"></div>
          <div>
            <div class="">  Cantidad de coutas a pagar</div>
            <div
              class="data-title"
            >
              {{flashPaymentService.controller.quantityToAccelerate}}
            </div>
          </div>
        </div>
      </div>

      <div class="prepaid-head-item">
        <div class="title-item">
          Monto total pagar
        </div>
        <div class="pay-action-container">
          <div class="amount"> {{ flashPaymentService.controller.operationAmount | currency }}</div>
          <div class="continue-button" (click)="goToProcess()">
            continuar
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
